import { Card, Table, TableContainer, TablePagination } from '@mui/material';
import { useState } from 'react';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import DynamicHeightComponent from 'src/utils/dynamicSize.component';
import NoApproval from '../../../assets/app-image/no-approval-posts.svg';
import PendingApprovalGridBody from './pending-approval-grid-body.component';
import PendingApprovalGridHead from './pending-approval-grid-head.component';

const PendingApprovalGrid = ({ pendingApprovalList, isOrgEvent, handleReCallPendingApprovalPost, order, orderBy,isShowOfferBanner=false  }) => {
  //Table Variables
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [height, setHeight] = useState(window.innerHeight - 110);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    let orderStr = isAsc ? 'desc' : 'asc';
    handleReCallPendingApprovalPost(property, orderStr);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };
  return (
    <>
      {pendingApprovalList && pendingApprovalList.length > 0 ? (
        <>
          <DynamicHeightComponent>
            <Scrollbar>
              <TableContainer
                sx={{
                  height: isShowOfferBanner ? 'calc(94vh - 226px)' : 'calc(94vh - 226px)',
                }}
              >
                <Table stickyHeader size="small">
                  <PendingApprovalGridHead
                    pendingApprovalList={pendingApprovalList}
                    orderBy={orderBy}
                    order={order}
                    handleRequestSort={handleRequestSort}
                  ></PendingApprovalGridHead>
                  <PendingApprovalGridBody
                    pendingApprovalList={pendingApprovalList}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isOrgEvent={isOrgEvent}
                    handleReCallPendingApprovalPost={handleReCallPendingApprovalPost}
                  ></PendingApprovalGridBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                rowsPerPageOptions={[10, 20, 30, 50]}
                count={pendingApprovalList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Scrollbar>
          </DynamicHeightComponent>
        </>
      ) : (
        <Card
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 'calc(100vh - 150px)',
            maxHeight: 'calc(100vh - 150px)',
          }}
        >
          <img
            src={NoApproval}
            style={{ width: '50%', height: '50%', maxWidth: '50%', maxHeight: '50%' }}
            alt="No Pending Approval"
          />
        </Card>
      )}
    </>
  );
};
export default PendingApprovalGrid;
